import { Base64 } from "js-base64";
import React, { useEffect, useState } from "react";
import { Button, Image, Spinner, Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";
import QRCode from "react-qr-code";
import { Link, useSearchParams } from "react-router-dom";
import { sendQrEmail, verifyOtp } from "../../api/User/Auth/verifyApi";
import "./style.css";
import showMoreIcon from "../../assets/icon/showMoreIcon.svg";
import hideIcon from "../../assets/icon/hideIcon.svg";
import { Collapse } from "react-collapse";
import { clearClientData } from "../../Redux/Reducer/ClientDataReducer";
import { useDispatch } from "react-redux";
import { POST } from "../../Service/Service";
import { SEND_QR_EMAIL } from "../../Service/Url";
import toastFile from "../../Service/ToastFile";

const Verify = ({ navigate }) => {
  const TIMER_START = 15;
  const MAX_ATTEMPT = 2;
  const dispatch = useDispatch();
  const [queryParameters] = useSearchParams();
  const [authURL, setAuthURL] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [error, setErrore] = useState("");
  const [empName, setEmpName] = useState("");
  const [isRegistred, setisRegistred] = useState(true);
  const [show, setShow] = useState(false);
  const [timer,setTimer] = useState(TIMER_START);
  const [qrLabel,setQrLabel] = useState("Send QR Code");
  const [attempts,setAttempts] = useState(0);
  const [qrButtonDisabled,setQrButtonDisabled] = useState(false)
  
  let timeInterval;

  const handleClose = () => {
    setShow(false);
    navigate("/");
  };

  useEffect(() => {
    if (queryParameters.get("s") !== null) {
      base64_url_decode(queryParameters.get("s"));
    }
  }, []);

  function base64_url_decode($input) {
    let query = Base64.decode($input);

    setAuthURL(query?.split("|")[1].slice(3));
    setEmail(query?.split("|")[2].slice(3));
    setEmpName(query?.split("|")[3].slice(3));
    setisRegistred(
      query?.split("|")[4].slice(4).split("=")[1].toLocaleLowerCase()
    );
  }
  const handleChange = (value) => {
    setErrore("");
    setOtp(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp) {
      setIsLoading(true);
      let encodedMsg = Base64.encode(`em=${email}|otp=${otp}`);
      verifyOtp(encodedMsg)
        .then((res) => {
          if (res?.status === 200 || res?.status === 204) {
            if (res.data.isSuccess) {
              setIsLoading(false);
              dispatch(clearClientData(null));
              if (!res.data.isActive) {
                setShow(true);
              } else {
                localStorage.setItem("token", res.data.accessToken);
                if (
                  res.data.role === "Client" ||
                  res.data.role === "Pharmacy" || 
                  res.data.role === "Clinician"
                ) {
                  navigate("/Welcome", {
                    state: {
                      email: email,
                      name: empName,
                      role: res.data.role,
                    },
                  });
                } else {
                  const queryEmail = email.split("@")[1];
                  if (
                    !(
                      queryEmail === "digbiconsulting.com" ||
                      queryEmail === "hubinternational.com" ||
                      queryEmail === "horanassoc.com" ||
                      queryEmail === "workplacebenefitsolutions.com"
                    )
                  ) {
                    navigate("login", { state: "email not match" });
                  } else {
                    if (res.data.isAlreadyRegistered) {
                      navigate("/Welcome", {
                        state: {
                          email: email,
                          name: empName,
                        },
                      });
                    } else {
                      navigate("/Register", {
                        state: {
                          email: email,
                          name: empName,
                        },
                      });
                    }
                  }
                }
              }
            } else {
              setIsLoading(false);
              setErrore("Invalide OTP");
            }
          }
        })
        .catch((res) => setIsLoading(false));
    } else {
      setErrore("OTP is required");
    }
  };
  const sendQr = async () => {
    if(attempts >= MAX_ATTEMPT){return;}

    setQrLabel("Sending...");
    setQrButtonDisabled(true);
    const data = await sendQrEmail(email);
    if (data.status == 200) {
      setAttempts(attempts+1)
      toastFile("Email sent successfully!","success");
      
      setQrLabel("Resend QR Code");
      setTimer(TIMER_START);
      if (timeInterval) clearInterval(timeInterval);

      timeInterval = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            clearInterval(timeInterval);
            attempts>=1 ? setQrButtonDisabled(true) : setQrButtonDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      toastFile("Failed to send email");
      setQrLabel("Send QR Code");
      if (timeInterval) clearInterval(timeInterval);
      setTimer(TIMER_START);
      setQrButtonDisabled(false);
      setAttempts(0);
    }
};
  return (
    <div className="d-flex flex-column vw-100 vh-100 align-items-center p-3">
      {/* modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>User Account Deactivated</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your account is inactive please contact support team
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button> */}
          <Button variant="primary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {/*verification */}
      <div className="verify-container">
        <h4 className="display-6 fw-bold text-nowrap">
          Configure authenticator app
        </h4>
        <p className="fs-5">
          Enter the code in the confirmation box below from authenticator app :{" "}
          <label
            style={{ color: "#007CC0" }}
            onClick={() => setisRegistred(!isRegistred)}
          >
            {isRegistred ? "show more" : "hide"}
            {"   "}
            {!isRegistred ? (
              <Image src={showMoreIcon} alt="show more icon" />
            ) : (
              <Image src={hideIcon} alt="hide icon" />
            )}
          </label>
        </p>
        <Collapse
          isOpened={!isRegistred}
          style={{ display: isRegistred ? "none" : "block" }}
        >
          <div>
            {" "}
            <ol
              className="list mt-3 fs-5 mt-5"
              style={{ transition: "0.5s easy-in-out" }}
            >
              <li>
                <p>
                  Download a two-factor authenticator app like Microsoft
                  Authenticator for
                  <Link
                    className="text-decoration-none"
                    to="https://go.microsoft.com/fwlink/?Linkid=825071"
                  >
                    {" "}
                    Windows Phone
                  </Link>
                  ,
                  <Link
                    className="text-decoration-none"
                    to="https://go.microsoft.com/fwlink/?Linkid=825072"
                  >
                    Android{" "}
                  </Link>
                  and
                  <Link
                    className="text-decoration-none"
                    to="https://go.microsoft.com/fwlink/?Linkid=825073"
                  >
                    {" "}
                    iOS{" "}
                  </Link>
                  or Google Authenticator for
                  <Link
                    className="text-decoration-none"
                    to="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=en"
                  >
                    {" "}
                    Android
                  </Link>{" "}
                  and
                  <Link
                    className="text-decoration-none"
                    to="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8"
                  >
                    {" "}
                    iOS
                  </Link>
                  .
                </p>
              </li>
              <li>
                <p>
                  Click the "Send QR Code" button below.The QR Code will be sent to your registered email address.
                </p>
              </li>
              <li>
                <p>
                  Scan the QR Code into your two factor authenticator app. Spaces and casing do not matter.
                </p>
              </li>
              <li>
                <p>
                  Once you have scanned the QR code or input the key above, your
                  two factor authentication app will provide you with a unique
                  code. Enter the code in the confirmation box below.
                </p>
                <div
                  style={{
                    height: "auto",
                    maxWidth: 150,
                    width: "100%",
                  }}
                  className=""
                >
                  <button className="btn btn-primary mt-4 fw-bold" onClick={sendQr} disabled={qrButtonDisabled}>
                    {qrLabel}
                  </button>
                </div>
                <div style={{'height':'25px'}}>
                  {attempts == MAX_ATTEMPT && <span className="text-danger" style={{'font-size':'15px'}}>maximum attempt reached</span>}
                  {(qrLabel.startsWith("Re") && attempts<MAX_ATTEMPT && timer > 0) && <span style={{'font-size':'15px'}}>Resend in 00:{String(timer).padStart(2, "0")}</span>}
                </div>
              </li>
            </ol>
          </div>
        </Collapse>
        <div className="row mt-5">
          <div className="col-md-6">
            <form className="gap-3" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="control-label">Verification Code</label>

                {/* <OtpInput
                  value={otp}
                  onChange={handleChange}
                  className="mt-1 border-1 w-100"
                  inputStyle="form-control w-100 py-2 border-dark fs-3"
                  numInputs={6}
                  shouldAutoFocus
                  separator={<span>-</span>}
                  hasErrored={error}
                  errorStyle="text-danger"
                  isInputNum={true}
                /> */}
               

                <OtpInput
                  value={otp}
                  onChange={handleChange}
                  numInputs={6}
                  shouldAutoFocus
                  renderSeparator={<span>-</span>}
                  renderInput={(inputProps, index) => (
                    <input
                      {...inputProps}
                      type="tel"                             // replaces isInputNum
                      className={`form-control w-100 py-2 border-dark fs-3 ${
                        error ? "text-danger" : ""
                      }`}
                    />
                  )}
                  containerStyle="mt-1 border-1 w-100"      // use containerStyle instead of className if needed
                />

                {error && (
                  <label
                    className="control-label mt-1 text-danger"
                    style={{ fontSize: "18px" }}
                  >
                    {error}
                  </label>
                )}
              </div>
              {isLoading ? (
                <Button
                  variant="primary"
                  className="mt-4 px-5 fw-bold"
                  disabled
                >
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="false"
                  />
                  <span className="px-2">Verify...</span>
                </Button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary mt-4 px-5 fw-bold"
                >
                  Verify
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
